import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
  DropdownMenuSeparator,
} from "@pushpress/pushpress-ui";
import StatusBadge from "./StatusBadge";
import { SubscriptionType, PEOPLE_TYPE } from "../../types";

export default function SubscriptionPopover({
  label,
  subscriptions,
}: {
  label: number;
  subscriptions: SubscriptionType[];
}) {
  return (
    <Tooltip>
      <TooltipTrigger>
        <span className="tw-text-neutral-600 tw-font-bold">&nbsp;+{label}</span>
      </TooltipTrigger>
      <TooltipContent className="tw-w-64 tw-p-4 tw-bg-white tw-shadow-lg tw-rounded-lg">
        {subscriptions.map((subscription, index) => (
          <div key={index}>
            <div className="tw-flex tw-items-center tw-justify-between tw-my-3">
              <span className="tw-text-neutral-800 tw-text-sm tw-truncate tw-max-w-[150px]">
                {subscription.name}
              </span>
              <StatusBadge
                peopleType={PEOPLE_TYPE.MEMBERS}
                status={subscription.status}
              />
            </div>
            {index < subscriptions.length - 1 && <DropdownMenuSeparator />}
          </div>
        ))}
      </TooltipContent>
    </Tooltip>
  );
}
